export const NumberFormatMixin = {
    methods: {
        numberCeil(number, area) {
            return parseFloat(number).toFixed(area);
        },

        reviewRatingAvg(sum, count) {
            let reviewAvg = 0;
            if(sum != 0 && count != 0) reviewAvg = sum/count;
            return (reviewAvg != 0) ? this.numberCeil(reviewAvg, 1) : '0.0';
        }
    }
};